import { render, staticRenderFns } from "./ProductShare.vue?vue&type=template&id=7033c2b6&"
import script from "./ProductShare.vue?vue&type=script&lang=js&"
export * from "./ProductShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports